import React from "react"

import { Modal as MuiModal } from "@mui/material"
import { Box, Button, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined"

type Prop = {
  open: boolean
  handleOpen: any
  handleDelete: any
}

export const CompanyDeleteModal = ({ open, handleOpen, handleDelete }: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "company" })

  const isPC = useMediaQuery({ query: "(min-width: 650px)" })

  return (
    <MuiModal open={open} disableAutoFocus={true}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isPC ? 680 : "98vw",
          maxHeight: "95vh",
          height: "260px",
          overflowY: "auto",
          bgcolor: "#FFF",
          boxShadow: 24,
          borderRadius: isPC ? "2px" : "1px",
          p: isPC ? "40px" : "10px",
        }}
      >
        <Box
          width="sm"
          display="flex"
          flexDirection="column"
          sx={{ borderRadius: "10px", bgcolor: "white", borderColor: "white", p: "0px" }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <DisabledByDefaultOutlinedIcon
              sx={{ color: "#00C298", cursor: "pointer", fontSize: "26px" }}
              onClick={() => handleOpen(false)}
            />
          </Box>
          <Typography.CardHead
            sx={{
              fontSize: "15px",
              fontWeight: "700",
              paddingBottom: "10px",
              borderBottom: "1px solid #F3F3F3",
            }}
          >
            {t("delete_confirm_title")}
          </Typography.CardHead>
          <Box sx={{ py: "10px", display: "flex", alignItems: "center", height: "120px" }}>
            <Typography.CardHead
              sx={{
                color: "#333333",
                fontSize: "14px",
                fontWeight: "400",
                letterSpacing: "0",
              }}
            >
              {t("delete_description")}
            </Typography.CardHead>
          </Box>

          <Box display="block" textAlign="right">
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Zen Kaku Gothic New !important",
                mt: "10px",
                mx: "0.5rem",
                width: "155px",
                height: "44px",
                fontSize: "15px",
                fontWeight: 700,
                borderRadius: "4px",
                borderColor: "#00C298",
                color: "#00C298",
              }}
              onClick={() => handleOpen(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Zen Kaku Gothic New !important",
                mt: "10px",
                mx: "0.5rem",
                width: "155px",
                height: "44px",
                fontSize: "15px",
                fontWeight: 700,
                borderRadius: "4px",
                backgroundColor: "#00C298",
                color: "white",
                "&:hover": {
                  color: "#00C298",
                },
              }}
              onClick={() => {
                handleDelete()
                handleOpen(false)
              }}
            >
              {t("button_delete")}
            </Button>
          </Box>
        </Box>
      </Box>
    </MuiModal>
  )
}
